import { cellToBoundary } from 'h3-js'
import React from 'react'
import { Layer, Source } from 'react-map-gl'
import { PLOT_COLORS } from '#app/consts'

export const PlotHovered = ({ plot }: { plot?: string }) => {
	if (!plot) return null

	const { selectedFill } = PLOT_COLORS

	const coordinates = cellToBoundary(plot, true)
	return (
		<React.Fragment key={`hovered-${plot}`}>
			<Source
				type="geojson"
				data={{
					type: 'FeatureCollection',
					features: [
						{
							type: 'Feature',
							geometry: {
								type: 'Polygon',
								coordinates: [coordinates],
							},
							id: plot,
							properties: {},
						},
					],
				}}
			>
				<Layer
					{...{
						id: `${plot}-fill-layer`,
						type: 'fill',
						paint: {
							'fill-color': selectedFill,
							'fill-opacity': 0.1,
						},
					}}
				/>
			</Source>
		</React.Fragment>
	)
}
